import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isSafari } from 'react-device-detect';

import { joinClassNames } from '../../../util/util';
import { setTransitionLayer, setTransitionEffectStatus } from '../../../actions/configurationActions';
import { PLAYER_TRANSITIONS_OUT } from '../../../util/constants';

import './TransitionLayer.scss';

const TransitionLayer = () => {
	const dispatch = useDispatch();
	const [dataUrl, setDataUrl] = useState('');
	const transitionRef = useRef<any>();

	const { showCountdownModule, currentMediaId, isTransitionLayerEnable, transitionType, isTransitionEffectActive, mediasData, isMediaLive } = useSelector(
		(state) => (state as any).configurationReducer
	);
	const activePlayerId = `player-${currentMediaId}`;
	const widget = (window as any).GoBrain.widgets(activePlayerId);
	const videoElement = widget?.element.querySelector('video.vjs-tech');

	const prepareImageData = (shouldUpdateSource: boolean) => {
		const canvas = document.createElement('canvas');
		const context = canvas.getContext('2d', { willReadFrequently: true });
		const width = videoElement?.videoWidth || window.innerWidth;
		const height = videoElement?.videoHeight || window.innerHeight;
		canvas.setAttribute('width', `${width}px`);
		canvas.setAttribute('height', `${height}px`);
		context && context.clearRect(0, 0, width, height);
		try {
			context && context.drawImage(videoElement, 0, 0, width, height);
			const newDataUrl = canvas.toDataURL('image/webp', 0.5);
			shouldUpdateSource && setDataUrl(newDataUrl);
		} catch (e) {}
	};

	const currentMedia = mediasData.find((media: any) => media?.id === currentMediaId);
	useEffect(() => {
		if (currentMedia?.live && !currentMedia?.start && !currentMedia?.end && currentMedia?.duration === 0) {
			dispatch(setTransitionLayer(false));
			dispatch(setTransitionEffectStatus(false));
		}

		setTimeout(
			() => {
				if (isTransitionEffectActive) {
					dispatch(setTransitionLayer(false));
					dispatch(setTransitionEffectStatus(false));
				}
			},
			transitionType == PLAYER_TRANSITIONS_OUT.fadeOut && !isSafari ? isMediaLive ? 100 : 1000 : 0
		);
	}, [transitionType, isTransitionEffectActive, dispatch, mediasData, currentMediaId, isTransitionLayerEnable, isMediaLive, currentMedia]);

	useEffect(() => {
		const screenshotInterval = setInterval(() => {
			prepareImageData(!isTransitionLayerEnable);
		}, 1000);

		return () => {
			clearInterval(screenshotInterval);
		};
	}, [videoElement, isTransitionLayerEnable]);

	// NOTE: Safari has transition performance issue when doing transition. So for safari we disable the fade effect

	return (
		<div
			ref={transitionRef}
			className={joinClassNames(
				'transition-wrapper',
				isTransitionLayerEnable && !showCountdownModule ? 'enabled' : '',
				isTransitionEffectActive && !isSafari ? `${transitionType}-effect` : ''
			)}
			style={{ backgroundImage: `url(${dataUrl})` }}
		/>
	);
};

export default TransitionLayer;
